import { render, staticRenderFns } from "./travel-information.vue?vue&type=template&id=b6996ff0&scoped=true&"
import script from "./travel-information.vue?vue&type=script&lang=js&"
export * from "./travel-information.vue?vue&type=script&lang=js&"
import style0 from "./travel-information.vue?vue&type=style&index=0&id=b6996ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6996ff0",
  null
  
)

export default component.exports